export default __webpack_public_path__ + "static/media/paymentOnboardingOne.10ca0af4.svg";